import { AxiosError } from 'axios'

import { CreateTaskResponse, createTask, CreateTaskBody } from '../../api/www'
import useSWRMutation from 'swr/mutation'

const MAX_RETRIES = 3
const BASE_DELAY = 3000

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

const createTaskWithRetry = async (
  deviceId: string,
  args: CreateTaskBody,
  retryCount = 0
): Promise<CreateTaskResponse> => {
  try {
    const response = await createTask(deviceId, args)
    return response.data
  } catch (error) {
    if (retryCount < MAX_RETRIES) {
      const delayMs = BASE_DELAY * Math.pow(2, retryCount)
      await delay(delayMs)
      return createTaskWithRetry(deviceId, args, retryCount + 1)
    }
    throw error
  }
}

export const useCreateTaskApi = (
  deviceId: string | undefined,
  args: CreateTaskBody
) => {
  const { data, trigger, error } = useSWRMutation<
    CreateTaskResponse,
    AxiosError<Error>
  >(deviceId && `/aos/task/create`, () =>
    createTaskWithRetry(deviceId ?? '', args)
  )

  return {
    data,
    trigger,
    error,
  }
}
